module.exports = __webpack_public_path__ + "static/media/menu.2f7d3a26.svg";